<template>
  <div id="page-wrapper-register">
    <div class="row">
      <div class="col-sm-4 col-sm-offset-4">
        <div class="panel panel-default">
          <div class="panel-heading register clearfix">
            <div><img :src="config.SITE_LOGOLOGIN" /></div>
            <h1
              class="page-header register"
              v-html="$t('register.open_demo_account')"
            ></h1>
          </div>
          <div class="panel-body">
            <div class="tab-content">
              <div class="tab-pane fade in active" id="profile">
                <form>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control"
                        id="firstName"
                        :placeholder="$t('register.first_name')"
                        v-model="model.firstName"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control"
                        id="lastName"
                        :placeholder="$t('register.last_name')"
                        v-model="model.lastName"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        :placeholder="$t('register.email')"
                        v-model="model.email"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        :placeholder="$t('register.phone')"
                        v-model="model.phone"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-4 col-md-3">
                      <label for="country" class="label-horizontal">{{
                        $t("register.country")
                      }}</label>
                    </div>
                    <div class="col-sm-4 col-md-5">
                      <select
                        v-model="model.countryEntity"
                        class="form-control"
                        id="countryEntity"
                        name="countryEntity"
                      >
                        <option v-for="v in countryList" :value="v">
                          {{ v.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="alert alert-info large" role="alert">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="beneficiary_confirmation"
                          v-model="model.acceptTerms"
                          @change="$v.model.acceptTerms.$touch()"
                        />
                        <span v-html="$t('register.accept_terms')"></span>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <spin-button
                        id="btnRegister"
                        :css-class="'btn btn-primary register btn-full-width mrg-r-15 mrg-b-25'"
                        :button-text="$t('register.create_account')"
                        :loading="spinners.register"
                        :loading-text="$t('shared.buttons.creating_account')"
                        :onClick="register"
                        v-bind:disabled="this.$v.model.$invalid"
                      ></spin-button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import RegisterService from "@/services/RegisterService";
import CommonService from "@/services/CommonService";
import swal from "sweetalert2";
import siteConfiguration from "@/config";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  email,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";

let srv = new CommonService();

export default {
  data() {
    return {
      model: {},
      spinners: {
        register: false,
      },
      config: siteConfiguration,
      countryList : []
    };
  },
  created(){
       srv.getCountries().then(r => {
        this.countryList = r.data;
      });
    },
  methods: {
    register() {
      let srv = new RegisterService();
      this.spinners.register = true;
      srv
        .register(this.model, true)
        .then((r) => {
          swal({
            position: "top-end",
            type: "success",
            title: this.$t("register.messages.account_created_ok"),
            showConfirmButton: false,
            timer: 1500,
          });
          this.model = {};
        })
        .catch((e) => {
          swal({
            position: "top-end",
            type: "error",
            title: e.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.spinners.register = false;
        });
    },
  },
  validations: {
    model: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
      },
      acceptTerms: {
        sameAs: sameAs(() => true),
      },
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/DemoAccountForm.vue